var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"title":_vm.$t('modal.nft.title')}},[_c('div',{staticClass:"nft_view_body"},[_c('ERC721View',{staticClass:"view",attrs:{"token":_vm.token,"index":_vm.tokenId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }